import template from './stimulus-document-viewer.component.html';
import { StimulusDocumentViewerController as controller } from './stimulus-document-viewer.controller';

export const stimulusDocumentViewer = {
	template,
	require: {mainController: '^feedbackSession'},
	controller,
	bindings: {media: '<ngModel'}
};
